import { Paginated } from '@mi-front/core';

/** Max page size accepted by audit matches CRUD list endpoints. */
export const AUDIT_MATCHES_CRUD_MAX_LIMIT = 1000;

/**
 * Converts ListingView sort (`field asc|desc`) to api-v2 CRUD sort (`field,ASC|DESC`).
 */
export function toCrudSort(sort?: string): string[] | undefined {
  if (!sort) {
    return undefined;
  }

  const [field, direction] = sort.split(' ');
  if (!field || !direction) {
    return undefined;
  }

  return [`${field},${direction.toUpperCase()}`];
}

/**
 * Builds datetime range CRUD filters used by spot and mention match lists.
 */
export function datetimeRangeCrudFilters(from: string, to: string): string[] {
  return [`datetime||$gte||${from}`, `datetime||$lte||${to}`];
}

/**
 * Maps an api-v2 CRUD list response to the `Paginated` shape ListingView expects.
 */
export function crudListToPaginated<T>(res: {
  data: T[];
  total: number;
  page: number;
  pageCount: number;
  count: number;
}): Paginated<T> {
  return {
    results: res.data,
    metadata: {
      pageIndex: Math.max(res.page - 1, 0),
      pagesCount: res.pageCount,
      showCount: res.count,
      totalCount: res.total,
    },
  };
}
